const isSlotDisabled = (slotHour, slotMinute, startTime) => {
  if (!startTime) {
    return false;
  }

  const [startHour, startMinute] = startTime.split(':').map(Number);

  if (slotHour <= startHour) {
    return true;
  } else if (startHour < slotHour && startMinute === 30 && slotMinute === 0) {
    return true;
  }

  return false;
}

export function generateTimeSlots(startTime = null) {
  const times = [];

  for (let hour = 0; hour < 24; hour++) {
    const hourString = hour < 10 ? `0${hour}` : `${hour}`;

    const slots = [`${hourString}:00`, `${hourString}:30`];

    slots.forEach(slot => {
      const [slotHour, slotMinute] = slot.split(':').map(Number);

      const disabled = isSlotDisabled(slotHour, slotMinute, startTime); //startTime && (slotHour < startHour || (slotHour === startHour && slotMinute < startMinute));

      times.push({ disabled, slot });
    });
  }

  return times;
}